import {
  type NavigationClickEvent,
  type TrackingPageType,
  navigationClickEventSchema
} from './interactiveTrackingEventSchema';
import logger from '../logger';

export const determinePageType = (refererUrl: URL): TrackingPageType => {
  if (refererUrl.pathname === '/') {
    return 'homepage';
  }

  if (refererUrl.pathname.includes('/p/')) {
    return 'product detail page';
  }

  if (refererUrl.pathname.includes('/c/')) {
    return 'product listing page';
  }

  if (refererUrl.pathname.includes('/cart/')) {
    return 'cart';
  }

  if (refererUrl.pathname.includes('/checkout/')) {
    return 'checkout';
  }

  if (refererUrl.pathname.includes('/b/') || refererUrl.pathname.includes('/marken')) {
    return 'brands';
  }

  logger.warn(`Unable to determine page type from referer URL: ${refererUrl.href}`);
  return 'unknown';
};

export type NavigationClickEventProps = Omit<
  NavigationClickEvent,
  'event' | 'event_name' | 'page_url' | 'page_type'
>;

export const buildNavigationClickEvent = (
  props: NavigationClickEventProps
): NavigationClickEvent => {
  const { click_name, click_position, click_url } = props;

  const navigationEvent: NavigationClickEvent = {
    event: 'ga4_event',
    event_name: 'navigation_click',
    page_url: globalThis.window.location.href,
    page_type: determinePageType(new URL(globalThis.window.location.href)),
    click_name,
    click_position,
    click_url
  };

  const result = navigationClickEventSchema.safeParse(navigationEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid navigation click event');
  }

  return navigationEvent;
};
